import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-flex p-3 bg-language d-flex flex-column gap-24px pb-4" };
const _hoisted_2 = { style: { "min-width": "175px" } };
const _hoisted_3 = {
    style: { "font-size": "13px" },
    class: "d-flex flex-column align-items-center"
};
const _hoisted_4 = { class: "text-start" };
const _hoisted_5 = { class: "mb-0 text-muted small" };
const _hoisted_6 = { class: "mb-0 text-muted small" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserLastModified',
    props: {
        updatedBy: { type: String },
        updatedAt: { type: String }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[0] || (_cache[0] = _createElementVNode("h6", { class: "updated-title" }, "Ultima modifica:", -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("p", _hoisted_5, _toDisplayString(__props.updatedBy) + " Nome utente", 1),
                            _createElementVNode("p", _hoisted_6, _toDisplayString(__props.updatedAt) + "Data ultima modifica", 1)
                        ])
                    ])
                ])
            ]));
        };
    }
});
